// used to display an informational banner in the report, may need to be made more generic
import React from 'react';
import Tooltip from '../../../Tooltip';
import { isValue } from '../../../../utility/isValue';
import renderValue from '../../utility/renderValue';
import classNames from '../../../../utility/classNames';
import { useLocation } from 'react-router-dom';

export default function ConditionalBannerSection({ section, data }) {
  //positive and negative message arrays should be of length 3 of strings
  const {
    positiveMessageArr,
    negativeMessageArr,
    sectionDescription,
    schema,
    sharing,
  } = section;
  const { pathname } = useLocation();

  if (!sharing && pathname.includes('/sharing')) return null;

  const compareWith = data[schema[0].name];
  const compare = data[schema[1].name];

  if (!isValue(compareWith, compare)) return null;

  const difference = compareWith - compare;

  const positive = difference < 0;
  const message = positive ? positiveMessageArr : negativeMessageArr;

  const compareLabel = renderValue(schema[1], data);
  const differenceLabel = renderValue(
    {
      ...schema[0],
      name: 'difference',
      label: 'Difference',
      unit: schema[0].unit || schema[1].unit,
    },
    { difference: Math.abs(difference) }
  );

  return (
    <aside className="pt-4 px-2 bg-primary-50">
      <div className="bg-white rounded-full px-4 py-2 flex flex-col justify-center items-center gap-[2px] border border-primary">
        <div className="text-center text-base font-medium text-neutral-800">
          {message[0]}
          <span
            className={classNames(
              'mr-1',
              positive ? 'text-green-700' : 'text-warning'
            )}
          >
            {compareLabel}.
          </span>

          {sectionDescription && (
            <Tooltip type="info" text={sectionDescription} offset="right-6" />
          )}
        </div>
        <p className="text-center text-md font-medium text-neutral-800">
          {message[1]}
          <span
            className={classNames(positive ? 'text-green-700' : 'text-warning')}
          >
            {differenceLabel}
          </span>
          {message[2]}
        </p>
      </div>
    </aside>
  );
}
